import { Injectable, inject } from '@angular/core';
import { FULL_STORAGE_URL } from '@math-site/services';
import { PostViewDto } from '@math-faculty/api-client';

@Injectable()
export class PostsContentReplacerService {
  private readonly storageUrl = inject(FULL_STORAGE_URL);

  replace(post: PostViewDto): PostViewDto {
    return {
      ...post,
      content: (post?.content ?? '')
        ?.replaceAll('https://math.uniyar.ac.ru', '')
        ?.replace(/https:\/\/[0-9a-zA-Z.-]*\/file\/get\//gi, this.storageUrl)
        ?.replace(/src="\/file\/get\//gi, `src="${this.storageUrl}`),
    };
  }
}
